<template>  
  <v-dialog      
    v-model="show"     
    :overlay="true"
    persistent
    max-width="600px"
    max-height="70%"      
    light   
    :hide-overlay="$vuetify.breakpoint.mobile"
    :fullscreen="$vuetify.breakpoint.mobile"    
    class="mt-4"   
    :scrollable="true"
  >    
    <div class="ctr" :style="top()">
      <v-row dense 
             justify="center"
             class="ma-1 text-uppercase"               
      > 
        <v-col cols="9">
          <v-card outlined style="border: 1px solid red;">
            <v-card-title v-if="openedFromReturn">
              Dina returer är sparade.
            </v-card-title> 
            <v-card-subtitle v-if="openedFromReturn">
              Behöver du ändra: Behåll bunten öppen och gå till Ändra/tillägg              
            </v-card-subtitle>
            <v-card-text>
              Slutför din rapportering genom att välja vilka buntar som skall behållas öppna.
              Du kan bara ha en öppen bunt per returtyp.
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-card v-for="type in listPaperTypes" 
              v-show="(openBundles(type).length > 0)"
              :key="type"              
              flat class="ctr"              
      >
        <v-card-title primary-title>
          <div class="text-h5 font-weight-light">
            Stäng buntar för - {{ paperTypes[type] }}
          </div>
          <v-spacer />        
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col v-for="bundle in openBundles(type)" :key="bundle.bundleId"
                   cols="6"
            >
              <v-card tile>
                <v-card-text align="center" class="pa-0">
                  <BundleProgress :bundle="bundle" :size="$vuetify.breakpoint.mobile?'regular':'large'" :extra="0" :name="bundle.id" />                                      
                </v-card-text>
                <v-card-actions class="justify-center pt-0">                  
                  <v-radio-group v-model="bundle.open" row hide-details="true">                    
                    <v-radio :value="true"
                             label="Öppen"
                             color="success"
                             off-icon="radio_button_unchecked"
                             on-icon="radio_button_checked" 
                    />                                         
                    <v-radio :value="false" 
                             label="Stängd"
                             color="error"
                             off-icon="radio_button_unchecked"
                             on-icon="radio_button_checked" 
                    />                                  
                  </v-radio-group>                          
                </v-card-actions>
              </v-card>                 
            </v-col>
          </v-row>
        </v-card-text>          
      </v-card>     
      <v-row dense 
             class="ma-1 text-uppercase"
             justify="end"
      >      
        <!-- <v-col cols="2" prepand="7">
          <v-btn ref="cancelBtn" 
                 label="Avbryt"
                 hide-details="auto"                     
                 dense
                 block
                 color="warning"                                    
                 @click="cancel()"              
          > 
            Avbryt
          </v-btn>
        </v-col>     -->
        <v-col cols="2" prepand="9">
          <v-btn ref="saveBtn" 
                 label="Spara"
                 hide-details="auto"                     
                 dense
                 block
                 color="primary"                            
                 :disabled="!valid"             
                 @click="confirm()"              
          > 
            Spara
          </v-btn>
        </v-col> 
      </v-row>
    </div>
  </v-dialog>
</template>

<script>
import { mapState, mapMutations} from 'vuex'
import { APP_VERSION, APP_OPEN_BUNDLES } from '@/store/appStates'
import { REMOVE_LAST_SELECTED_BUNDLE_ID, SET_OPEN_BUNDLES } from '@/store/appMutations'
import DialogMixin from '@/components/web/dialogs/DialogMixin'
import BundleProgress from '@/components/web/BundleProgress'
import api from '@/backend/api'
import log from '@/logger'
import * as pt from '@/model/paperTypes'

export default {
  name:'ConfirmReportDialog',
  components:{ BundleProgress },
  mixins: [DialogMixin],  
  props: {       
    openedFromReturn: { 
      default:false,
      type:Boolean,
      required: false }
  }, 
  data(){
    return{
      paperTypes: pt.types,
      listPaperTypes: [ pt.NEWSPAPER, pt.INSERT ],
    }
  },  
  computed: {   
    ...mapState({
      version: state => state[APP_VERSION],
      theBundles: state => state[APP_OPEN_BUNDLES]
    }),  
    openBundles() {
      return type=>this.theBundles[type]
    },
    allBundles(){
      return this.theBundles[pt.NEWSPAPER].concat(this.theBundles[pt.INSERT])
    },

    valid(){      
      if(this.allBundles.filter(p=> p.open=== undefined).length > 0 ){
        return false
      }
      return ( this.openBundles(this.listPaperTypes[0]).filter(p=> p.open===true && p.type === this.listPaperTypes[0]).length < 2 )
          && ( this.openBundles(this.listPaperTypes[1]).filter(p=> p.open===true  && p.type === this.listPaperTypes[1]).length < 2 )
    }
  }, 
   watch: {
    'show': function (val) {
        console.log('Show ' + val)
        if(val){        
          var bundles =[]
          this.openBundles(this.listPaperTypes[1]).forEach(b=>{
            this.$set(b,'open',undefined)
            bundles.push(b)
          })          
          this.setOpenBundles({ bundles: bundles, paperType:1})
          bundles =[]
           this.openBundles(this.listPaperTypes[0]).forEach(b=>{
            this.$set(b,'open',undefined)
            bundles.push(b)
          })
          this.setOpenBundles({ bundles: bundles, paperType:0})
        }
    }
  },
  mounted(){
    if(this.model === undefined){
      console.log('No model')
    }
  },
 
  methods:{
     ...mapMutations({
      removeClosedBundle: REMOVE_LAST_SELECTED_BUNDLE_ID,      
      setOpenBundles: SET_OPEN_BUNDLES,
    }),       
    closeBundle(bundle){
      api.closeBundle(bundle.id).then(resp=>{
        log.debug('Bundle stored and closed:', resp.data)
        this.removeClosedBundle({bundleId:bundle.id})         
      })
      .catch(error => {
        log.debug('Error', error.data)
      }) 
    },
    cancel(){
       this.saved()
    },
    confirm(){
      let errorCount = 0
      this.allBundles.filter(p=>p.open === false).forEach(b => {
        api.closeBundle(b.id).then(resp => {
       // api.storeTemporary(b.id).then(resp => {
          log.debug('Bundle stored and closed:', resp.data)
          //this.openBundles.filter(p=>p.open === false).forEach(b => {
            this.removeClosedBundle({bundleId:b.id})             
          //})
        }).catch(error => {
           errorCount += 1
           log.debug('Error', error.data)
        })     
      })     
      if(errorCount == 0){
        var mainPaper = api.getOpenBundles(0).then(resp => {       
          this.setOpenBundles({ bundles: resp.data, paperType:0})          
        })        
        var insetPaper = api.getOpenBundles(1).then(resp => {        
          this.setOpenBundles({ bundles: resp.data, paperType:1})
        })
        Promise.all([mainPaper,insetPaper])
        this.saved()
      }
    },
     top(){      
       if(this.$vuetify.breakpoint.mobile)
        return 'padding-top:6em'      
    }
  }
}
</script>

<style lang="scss" scoped>
  .ctr{
    background-color:white
  }
  .v-dialog{
    top:8em!important
  }
</style>
